import {ScrollTopAnimation} from './animations/ScrollTopAnimation';
import {HeightAnimation} from './animations/HeightAnimation';
import {FadeAnimation} from './animations/FadeAnimation';
import {GroupAnimation} from './animations/GroupAnimation';
import {TimeoutPromise} from './promises/TimeoutPromise';

declare var Drupal:any;

export class FormSubmitHandler {

    constructor(private form:JQuery<HTMLFormElement>) {
        form.on("invalid",(ev)=>this.invalid(ev));
        form.on("submit",(ev)=>this.submit(ev));
    }

    private async invalid(ev:JQuery.TriggeredEvent) {
        let errorElements=[
            '.anyform-errors li',
            'input.error',
            '.select.error',
            '.anyform-has-error .select',
            '.form-type-checkbox.anyform-has-error',
            'textarea.error',
            'fieldset.anyform-has-error',
            '.anyform-error'
        ];
        let errors=this.form.find(errorElements.join(',')).filter(':visible');
        let topMost=this.getTopmostElement(errors);
        if (!topMost) return;
        topMost[0].focus({preventScroll:true});
        let scrollParent=this.getScrollableParent(this.form);
        let target=this.getScrollTarget(topMost, scrollParent)-this.getScrollPadding(scrollParent);
        await new ScrollTopAnimation(scrollParent).to(target).play();
    }

    private getTopmostElement(els:JQuery<HTMLElement>) {
        let minTop=Number.MAX_SAFE_INTEGER;
        let minElement;
        for (let el of els) {
            let ofs=$(el).offset();
            if (ofs===undefined) continue;
            let top=ofs.top;
            if (top<minTop) {
                minTop=top;
                minElement=$(el);
            }
        }
        return minElement;
    }

    private getScrollTarget(elem:JQuery<HTMLElement>, scrollParent:JQuery<HTMLElement>):number {
        let elTop=elem.offset()?.top??0;
        if (scrollParent.is('html')) return elTop;
        let containerTop=scrollParent.offset()?.top??0;
        return elTop-containerTop+(scrollParent.scrollTop()??0);
    }

    private getScrollPadding(scrollParent:JQuery<HTMLElement>):number {
        return parseFloat(scrollParent.css('scrollPaddingTop'))||0;
    }

    private getScrollableParent(elem:JQuery<HTMLElement>) {
        let result=elem.parents().filter(function() {
            return /(auto|scroll)/.test($(this).css("overflow-y"));
        }).first();
        if (result.length) return result;
        return $('html');
    }

    private async submit(ev:JQuery.TriggeredEvent) {
        if ((ev as any).html) {
            let form=$(ev.currentTarget);
            // tabindex=-1 is necessary to focus this div later
            let sr=$('<div class="submit-result" tabindex="-1">'+(ev as any).html+'</div>').insertAfter(form);
            let height=sr.height();
            sr.css('display','none');
            await new FadeAnimation(form).from(1).to(0).play();
            let scrollParent=this.getScrollableParent(form);
            scrollParent.css('transition','scroll-top .3s ease');
            form.css('overflow','hidden');

            let baseOffset=this.getScrollPadding(scrollParent);
            let formOffset=this.getScrollTarget(form, scrollParent);

            await new GroupAnimation(
                new HeightAnimation(form).from('auto').to(height??0),
                new ScrollTopAnimation(scrollParent).to(formOffset-baseOffset),
            ).play();
            scrollParent.css('transition','');
            form.remove();
            Drupal.attachBehaviors(sr[0]);
            await new FadeAnimation(sr).from(0).to(1).play();
            // The 1ms delay is necessary to prevent :focus-within from being triggered
            await new TimeoutPromise(1);
            let nativeSr=(sr[0] as any);
            nativeSr.focus({focusVisible:false});
       }
        if ((ev as any).redirect) window.location=(ev as any).redirect;
    }

}

export {};